export const ADD_SELECTION = 'editorState/ADD_SELECTION';
export const CLEAR_SELECTION = 'editorState/CLEAR_SELECTION';
export const CLEAR_STAGE_SELECTIONS = 'editorState/CLEAR_STAGE_SELECTIONS';
export const SHOW_CONFIRM_DELETE_MODAL = 'editorState/SHOW_CONFIRM_DELETE_MODAL';
export const SHOW_COMMENT_DELETE_CONFIRMATION = 'editorState/SHOW_COMMENT_DELETE_CONFIRMATION';
export const SHOW_TEMPLATE_MODAL = 'editorState/SHOW_TEMPLATE_MODAL';
export const ADD_ACTIVE_PLUGIN_ID = 'ADD_ACTIVE_PLUGIN_ID';

export const STAGE_ELEMENT_TYPES = {
  SECTION: 'stage-section',
  PLACEHOLDER: 'stage-element-placeholder',
  TEXT: 'stage-element-text',
  IMAGE: 'stage-element-image',
  PLUGIN: 'stage-element-component-plugin',
  EMBED: 'stage-element-embedded-html',
  TABLE: 'stage-element-table',
  SHOWHIDE: 'stage-element-show-hide',
};
